import { useCallback, useRef, useState } from 'react';
import { useEventListener } from 'usehooks-ts';

interface ScrollVisibilityOptions {
  // 是否使用透明度
  hasOpacity?: boolean;
  // 是否使用位移
  hasTransform?: boolean;
  // 自定义隐藏时的透明度
  hiddenOpacity?: number;
  // 自定义隐藏时的位移距离（像素）
  hiddenTransform?: number;
}

export function useScrollVisibility(options: ScrollVisibilityOptions = {}) {
  const {
    hasOpacity = false,
    hasTransform = false,
    hiddenOpacity = 0.3,
    hiddenTransform = -100,
  } = options;

  const lastScrollYRef = useRef(0);
  const lastScrollTimeRef = useRef(Date.now());
  const [translateY, setTranslateY] = useState(0);
  const [opacity, setOpacity] = useState(1);

  const handleScroll = () => {
    const currentTime = Date.now();
    const currentScrollY = window.scrollY;
    const isScrollingUp = currentScrollY < lastScrollYRef.current;
    const isQuickScroll = currentTime - lastScrollTimeRef.current < 150;

    const shouldShow = currentScrollY === 0 || (isScrollingUp && isQuickScroll);

    if (hasOpacity) {
      setOpacity(shouldShow ? 1 : hiddenOpacity);
    }
    if (hasTransform) {
      setTranslateY(shouldShow ? 0 : hiddenTransform);
    }

    lastScrollYRef.current = currentScrollY;
    lastScrollTimeRef.current = currentTime;
  };

  useEventListener('scroll', handleScroll);

  // 重置状态
  const reset = useCallback(() => {
    setOpacity(1);
    setTranslateY(0);
    lastScrollYRef.current = 0;
    lastScrollTimeRef.current = Date.now();
  }, []);

  return { opacity, reset, translateY };
}
